module.exports = __webpack_public_path__ + "static/media/06.9e2df90d.jpg";